const inclusiveCallOrder = {
  NONE: 1
}

const dealTypeOrder = {
  BROADBAND_ONLY: 0,
  BROADBAND_AND_TV: 1,
  TV_ONLY: 2,
  PHONE_ONLY: 3
}

const broadbandTypesOrder = {
  FIBRE: 0,
  STANDARD: 1,
  FAST_MOBILE: 2,
  NONE: 3
}

const orderedSort = (order) => (a, b) => order[a.value] > order[b.value] ? 1 : -1

export const dealTypeSort = orderedSort(dealTypeOrder)

export const broadbandTypesSort = orderedSort(broadbandTypesOrder)

export const alphaSortList = (a, b) => (a.value.toUpperCase() < b.value.toUpperCase() ? -1 : 1)

export const alphaNameSortList = (a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1)

export const inclusiveCallSort = (a, b) => (inclusiveCallOrder[a.value] || 0) - (inclusiveCallOrder[b.value] || 0)
